if (process.env.WEBPACK === 'site.dev') {
  module.exports = require('./devRoutes')
}
else {
  module.exports = require('./routes')
}
